import { jsxs as l, jsx as o } from "react/jsx-runtime";
const c = (r) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...r,
    children: [
      /* @__PURE__ */ o(
        "path",
        {
          fill: "currentColor",
          d: "M31.995 6.032c-14.343 0-25.971 11.628-25.971 25.971s11.628 25.971 25.971 25.971 25.971-11.628 25.971-25.971S46.338 6.032 31.995 6.032Zm15.538 41.511a21.896 21.896 0 0 1-15.538 6.436c-2.968 0-5.846-.58-8.553-1.725a21.929 21.929 0 0 1-6.986-4.711 21.896 21.896 0 0 1-6.436-15.538c0-2.968.58-5.846 1.725-8.553a21.918 21.918 0 0 1 4.711-6.986 21.896 21.896 0 0 1 15.539-6.436c2.969 0 5.845.58 8.552 1.725a21.918 21.918 0 0 1 6.986 4.711 21.896 21.896 0 0 1 6.436 15.539c0 2.969-.58 5.845-1.725 8.552a21.929 21.929 0 0 1-4.711 6.986Z"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          fill: "currentColor",
          d: "m43.455 21.785-.002-.002-14.784 14.784-6.483-6.483-2.826 2.825 9.309 9.309 15.969-15.969-1.184-4.463.001-.001Z"
        }
      )
    ]
  }
);
export {
  c as Confirmation
};
